import { axiosV2 } from 'interceptors/axios';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

export const getPartnersByFieldsAndQuery =
  (societyId: string, params: any) => async (dispatch: any) => {
    const query = { params: { societyId, ...params } };

    try {
      const { data } = await axiosV2.get('/partners', query);

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
